import * as React from "react";
const SvgStore = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#6366F1"
      d="M3.833 6.25V4.333h15.334V6.25H3.833Zm0 13.417v-5.75h-.958V12l.958-4.792h15.334L20.125 12v1.917h-.958v5.75H17.25v-5.75h-3.833v5.75H3.833ZM5.75 17.75h5.75v-3.833H5.75v3.833Z"
    />
  </svg>
);
export default SvgStore;